module.exports = __webpack_public_path__ + "c4fd72c98460662d7522405092df7835.svg";